module.exports = __webpack_public_path__ + "resources/img/img-acra-point-01-m.1af4bf0a24bd327010c002d2b0f1e027.png";